// 다이빙풀 데이터
export interface DivingPool {
  id: string
  name: string
  depth: string
  address: string
  region: string
  level: 'beginner' | 'intermediate' | 'advanced'
  features?: string[]
  lat: number  // 위도
  lng: number  // 경도
  phone?: string  // 전화번호
  website?: string  // 웹사이트
  parkingInfo?: string  // 주차 정보
  priceInfo?: string  // 가격 정보
  operatingHours?: string  // 운영 시간
  imageUrl?: string  // 대표 이미지
}

export const divingPools: DivingPool[] = [
  // 서울/경기 - 초급 (5-7m)
  {
    id: 'jamsil',
    name: '잠실종합운동장 다이빙풀',
    depth: '5m',
    address: '서울 송파구 올림픽로 25',
    region: '서울',
    level: 'beginner',
    features: ['서울 최대 규모', '공공 다이빙풀', '대중교통 편리'],
    lat: 37.5153,
    lng: 127.0732,
    phone: '02-2240-8812',
    parkingInfo: '잠실종합운동장 주차장 이용 가능 (유료)',
    operatingHours: '화~일 09:00-18:00 (월요일 휴무)',
    priceInfo: '1회 입장 10,000원'
  },
  {
    id: 'aqualine',
    name: '아쿠아라인',
    depth: '5m',
    address: '경기 성남시 중원구 제일로 60',
    region: '경기',
    level: 'beginner',
    features: ['프리다이빙 전문', '교육 시설', '장비 렌탈'],
    lat: 37.4449,
    lng: 127.1388,
    phone: '031-746-5500',
    parkingInfo: '건물 내 주차장 무료',
    operatingHours: '매일 06:00-22:00',
    priceInfo: '프리다이빙 레인 20,000원/2시간'
  },
  {
    id: 'songdo',
    name: '송도 스포츠파크',
    depth: '5m',
    address: '인천 연수구 송도동 380',
    region: '인천',
    level: 'beginner',
    features: ['최신 시설', '넓은 공간', '수영장 병행'],
    lat: 37.3835,
    lng: 126.6561,
    phone: '032-832-5000',
    parkingInfo: '지하주차장 무료 (2시간)',
    operatingHours: '06:00-22:00 (연중무휴)',
    priceInfo: '일일권 8,000원'
  },
  {
    id: 'worldcup',
    name: '수원 월드컵경기장 수영장',
    depth: '5m',
    address: '경기 수원시 팔달구 월드컵로 310',
    region: '경기',
    level: 'beginner',
    features: ['월드컵 경기장 내', '쾌적한 환경'],
    lat: 37.2845,
    lng: 127.0356,
    phone: '031-259-2100',
    parkingInfo: '경기장 주차장 이용 (2,000원/일)',
    operatingHours: '06:00-21:00',
    priceInfo: '일반 5,000원'
  },
  {
    id: 'arpia',
    name: '아르피아',
    depth: '5m',
    address: '경기 용인시 수지구 포은대로 499',
    region: '경기',
    level: 'beginner',
    features: ['프리다이빙 전문', '초보자 친화적'],
    lat: 37.3234,
    lng: 127.0891,
    phone: '031-262-5252',
    parkingInfo: '건물 앞 무료 주차',
    operatingHours: '10:00-22:00',
    priceInfo: '프리다이빙 입장 25,000원'
  },
  {
    id: 'sujak',
    name: '수작 코리아',
    depth: '7m',
    address: '경기 고양시 덕양구 동헌로 235',
    region: '경기',
    level: 'beginner',
    features: ['다양한 수심', '전문 교육', '장비샵'],
    lat: 37.6528,
    lng: 126.8362,
    phone: '031-961-5000',
    parkingInfo: '건물 지하주차장 무료',
    operatingHours: '09:00-21:00',
    priceInfo: '입장료 30,000원/3시간'
  },

  // 중급 (10-15m)
  {
    id: 'tsn',
    name: 'TSN 오산',
    depth: '11m',
    address: '경기 오산시 청학로 286',
    region: '경기',
    level: 'intermediate',
    features: ['실내 최고 깊이', '전문 교육', '따뜻한 수온'],
    lat: 37.1455,
    lng: 127.0695,
    phone: '031-374-7700',
    parkingInfo: '전용 주차장 무료 (50대)',
    operatingHours: '09:00-22:00',
    priceInfo: '프리다이빙 35,000원/3시간'
  },

  // 상급 (20m+)
  {
    id: 'k26',
    name: 'K26 가평',
    depth: '26m',
    address: '경기 가평군 청평면 고재길 262',
    region: '경기',
    level: 'advanced',
    features: ['국내 최고 깊이', '딥 다이빙', '자연경관'],
    lat: 37.7312,
    lng: 127.4276,
    phone: '031-585-2600',
    parkingInfo: '대형 주차장 무료',
    operatingHours: '09:00-18:00 (동절기 단축)',
    priceInfo: '입장료 50,000원'
  },
  {
    id: 'paradive35',
    name: '파라다이브 35',
    depth: '35m',
    address: '경기 시흥시 거북섬 중앙로 1',
    region: '경기',
    level: 'advanced',
    features: ['아시아 최고 깊이', '실내 다이빙풀', '연중 운영'],
    lat: 37.3567,
    lng: 126.7089,
    phone: '031-431-3500',
    parkingInfo: '지하주차장 무료 (200대)',
    operatingHours: '09:00-21:00',
    priceInfo: '프리다이빙 60,000원/4시간',
    website: 'https://paradive35.com'
  },
  {
    id: 'deepstation',
    name: '딥스테이션',
    depth: '36m',
    address: '경기 용인시 처인구 포곡읍 성산로 523',
    region: '경기',
    level: 'advanced',
    features: ['세계 최고 수준', '딥 다이빙 시설', '수중터널'],
    lat: 37.2847,
    lng: 127.2156,
    phone: '031-336-3600',
    parkingInfo: '무료 주차 (300대)',
    operatingHours: '10:00-19:00',
    priceInfo: '다이빙 체험 70,000원~',
    website: 'https://deepstation.co.kr'
  }
]

// 지역별 다이빙풀 필터링
export const getDivingPoolsByRegion = (region: string): DivingPool[] => {
  return divingPools.filter(pool => pool.region === region)
}

// 레벨별 다이빙풀 필터링
export const getDivingPoolsByLevel = (level: 'beginner' | 'intermediate' | 'advanced'): DivingPool[] => {
  return divingPools.filter(pool => pool.level === level)
}

// 사용자 레벨에 맞는 다이빙풀 추천
export const getRecommendedPools = (userLevel: string): DivingPool[] => {
  const levelMap: Record<string, ('beginner' | 'intermediate' | 'advanced')[]> = {
    'student': ['beginner'],
    'aida1': ['beginner'],
    'aida2': ['beginner', 'intermediate'],
    'aida3': ['beginner', 'intermediate', 'advanced'],
    'aida4': ['beginner', 'intermediate', 'advanced'],
    'instructor': ['beginner', 'intermediate', 'advanced'],
    // PADI
    'padi_basic': ['beginner'],
    'padi_freediver': ['beginner'],
    'padi_advanced': ['beginner', 'intermediate'],
    'padi_master': ['beginner', 'intermediate', 'advanced'],
    'padi_instructor': ['beginner', 'intermediate', 'advanced'],
    // 기타
    'beginner': ['beginner'],
    'intermediate': ['beginner', 'intermediate'],
    'advanced': ['beginner', 'intermediate', 'advanced'],
    'master': ['beginner', 'intermediate', 'advanced']
  }

  const allowedLevels = levelMap[userLevel] || ['beginner']
  return divingPools.filter(pool => allowedLevels.includes(pool.level))
}

// 지도 중심점 계산 (모든 풀장의 중심)
export const getMapCenter = (): { lat: number; lng: number } => {
  const avgLat = divingPools.reduce((sum, pool) => sum + pool.lat, 0) / divingPools.length
  const avgLng = divingPools.reduce((sum, pool) => sum + pool.lng, 0) / divingPools.length
  return { lat: avgLat, lng: avgLng }
}
